import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatErr(detail) {
  if (!detail) return "حدث خطأ، حاول مرة أخرى";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" - ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export function fileUrl(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
}

export function fmtIQD(n) {
  const num = Math.round(Number(n) || 0);
  return num.toLocaleString("en-US") + " د.ع";
}

export function fmtNum(n) {
  return Number(n || 0).toLocaleString("en-US");
}

export function fmtDate(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString("ar-IQ-u-nu-latn"); } catch { return ""; }
}

export function fmtDateTime(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleString("ar-IQ-u-nu-latn"); } catch { return ""; }
}

// Normalize Arabic/Persian digits in user input to Latin before validation
export function toLatinDigits(s) {
  if (s == null) return s;
  return String(s)
    .replace(/[٠-٩]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0x0660 + 48))
    .replace(/[۰-۹]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0x06F0 + 48));
}
